export enum ScheduleFrequencyEnum {
    NotSet = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export function ScheduleFrequencyEnumToI18n(val: ScheduleFrequencyEnum): string {
    console.log(val);
    switch (val) {
        case ScheduleFrequencyEnum.Daily:
            return "scheduleconfiguration.daily";
        case ScheduleFrequencyEnum.Weekly:
            return "scheduleconfiguration.weekly";
        case ScheduleFrequencyEnum.Monthly:
            return "scheduleconfiguration.monthly";
        default:
            return "common.notSet";
    }
}
